
import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Button, Form, Row, Col } from "react-bootstrap";
import styles from "../../../layout/Auth/Auth.module.scss";
import OTPInput from "react-otp-input";
import { useFormik } from "formik";
import { VerifyOtp } from "../../../store/actions";
import * as Yup from "yup";
import { toast } from "react-toastify";
import { useDispatch } from "react-redux";

const Otp = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const email = location.state?.email || "";
  const [isLoading, setIsLoading] = useState(false);
  useEffect(() => {
    if (!email) {
      navigate("/forgot-password");
    }
  }, [email, navigate]);

  const validationSchema = Yup.object({
    email: Yup.string().email().required("Email is required"),
    OTP: Yup.string()
      .matches(/^\d{4}$/, "OTP must be exactly 4 digits")
      .required("OTP is required"),
  });

  const formik = useFormik({
    initialValues: {
      email: email,
      OTP: "",
    },
    validationSchema,
    validateOnChange: false,
    onSubmit: (values, { setFieldValue, resetForm }) => {
      setIsLoading(true);
      try {
        const callBack = (err, response) => {
          const { status, status_code, message } = response || {};
          setIsLoading(false);
          if (status === "success" && status_code === 200) {
            toast.success(message);
            navigate("/reset-password");
          } else {
            if (message) toast.error(message);
            setFieldValue("OTP", "");
          }
        };
        dispatch(VerifyOtp({ data: values, callBack }));
      } catch (err) {
        setIsLoading(false);
        if (err?.message) toast.error(err.message);
        setFieldValue("OTP", "");
        console.log(err, "<====err");
      }
    },
  });

  return (
    <div className="formInner position-relative px-lg-3">
      <div className="w-100 inner">
        <div className="top pt-2 text-center border-bottom border-secondary">
          <h5 className="m-0 fw-bold py-1 text-muted">Enter OTP</h5>
        </div>
        <Form
          onSubmit={formik.handleSubmit}
          className={`${styles.form} pt-lg-4 pt-2`}
        >
          <Row className="justify-content-center">
            <Col lg="12" className="my-2 text-center">
              <div className="otpWrp">
                <OTPInput
                  value={formik.values.OTP}
                  onChange={(otp) => formik.setFieldValue("OTP", otp)}
                  numInputs={4}
                  isInputNum
                  shouldAutoFocus
                  renderInput={(props) => (
                    <input
                      {...props}
                      className={`form-control m-1 text-center ${styles.otpInput}`}
                      style={{ width: "40px", height: "40px" }}
                    />
                  )}
                />
              </div>
              {formik.errors.OTP && (
                <div className="text-danger mt-1 small">
                  {formik.errors.OTP}
                </div>
              )}
            </Col>
            <Col lg="12" className="my-2 text-center">
              <Button
                type="submit"
                disabled={isLoading}
                className="d-inline-flex align-items-center justify-content-center commonBtn rounded-pill fw-bold"
              >
                {isLoading ? "Verifying..." : "Submit"}
              </Button>
            </Col>
          </Row>
        </Form>
      </div>
    </div>
  );
};

export default Otp;
